module.exports = require('./helpers/bundle-url').getBundleURL('b42qH') + "logo-dark.eefe0b7f.svg";